import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import SubmissionFailed from './components/SubmissionFailed.vue';
import SubmissionSuccess from './components/SubmissionSuccess.vue';
import Contact from './views/Contact';
import About from './views/About';
import Gallery from './views/Gallery';
import VillaAndaluza from './views/VillaAndaluza';
import VillaVeranza from './views/VillaVeranza';
import BlueBay301 from './views/BlueBay301';
import BlueBay302 from './views/BlueBay302';



Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/success',
			name: 'success',
			component: SubmissionSuccess
		},
		{
			path: '/404',
			name: 'fail',
			component: SubmissionFailed
		},
		{
			path: '/contact',
			name: '/contact',
			component: Contact
		},
		{
			path: '/about',
			name: '/about',
			component: About
		},
		{
			path: '/gallery',
			name: '/gallery',
			component: Gallery
		},

		//Villas

		{
			path: '/villaandaluza',
			name: '/villaandaluza',
			component: VillaAndaluza
		},
		{
			path: '/villaveranza',
			name: '/villaveranza',
			component: VillaVeranza
		},
		{
			path: '/bluebay301',
			name: '/bluebay301',
			component: BlueBay301
		},
		{
			path: '/bluebay302',
			name: '/bluebay302',
			component: BlueBay302
		},
	],
	scrollBehavior() {
		return { x: 0, y: 0 };
	}
});
